import { render } from "./EnhancedSecurity.vue?vue&type=template&id=efbcec78&scoped=true"
import script from "./EnhancedSecurity.vue?vue&type=script&lang=js"
export * from "./EnhancedSecurity.vue?vue&type=script&lang=js"

import "./EnhancedSecurity.vue?vue&type=style&index=0&id=efbcec78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbcec78"]])

export default __exports__